import { useEffect, useState } from 'react';

const measure = (breakpoint) =>
    typeof window === 'undefined' ? false : window.innerWidth <= breakpoint;

export const useDeviceSizeListener = ({ breakpoint }) => {
    const [isMobile, setIsMobile] = useState(() => measure(breakpoint));

    useEffect(() => {
        if (typeof window === 'undefined') return undefined;
        const query = `(max-width: ${breakpoint}px)`;
        const mql = window.matchMedia(query);
        const handle = (e) => setIsMobile(e.matches);
        setIsMobile(mql.matches);
        if (mql.addEventListener) {
            mql.addEventListener('change', handle);
            return () => mql.removeEventListener('change', handle);
        }
        mql.addListener(handle);
        return () => mql.removeListener(handle);
    }, [breakpoint]);

    return { isMobile };
};
